(() => {
  const patchZoomOpen = () => {
    const ZoomDialog = customElements.get('zoom-dialog');
    if (!ZoomDialog || ZoomDialog.prototype.__almZoomPatched) return;

    const originalOpen = ZoomDialog.prototype.open;

    ZoomDialog.prototype.open = async function openWithoutFlash(index, event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      const { dialog, media, thumbnails } = this.refs || {};
      if (!dialog || !media) {
        return originalOpen.call(this, index, event);
      }

      const targetImage = media[index];
      const targetThumbnail = thumbnails?.children?.[index];

      // Instant white overlay — skip view-transition morph that causes the flash
      dialog.style.backgroundColor = '#ffffff';
      dialog.style.opacity = '1';
      dialog.showModal();

      for (const target of [targetThumbnail, targetImage]) {
        target?.scrollIntoView?.({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }

      if (typeof this.selectThumbnail === 'function') {
        this.selectThumbnail(index, { behavior: 'instant' });
      }

      if (typeof this.loadHighResolutionImage === 'function' && targetImage) {
        this.loadHighResolutionImage(targetImage);
      }
    };

    ZoomDialog.prototype.__almZoomPatched = true;
  };

  if (customElements.get('zoom-dialog')) {
    patchZoomOpen();
  } else {
    customElements.whenDefined('zoom-dialog').then(patchZoomOpen);
  }
})();
